import React from "react";
import CustomModal from "../../common/CustomModal";
import AdRequestCreate from "../AdRequestCreate";

const SingleAdRequestModal = ({ open, onClose }) => (
  <CustomModal
    open={open}
    title="Create a single ad request"
    onClose={onClose}
    isButtonsRequired={false}
    bodyClassName="bg-[#f7f7fb]"
    className="md:!w-[92%] lg:!w-[80%]"
  >
    <AdRequestCreate onSuccess={onClose} />
  </CustomModal>
);

export default SingleAdRequestModal;
